import { UNICODE_EXTENSION_SEQUENCE_REGEX } from './utils';
import { BestAvailableLocale } from './BestAvailableLocale';
/**
 * https://tc39.es/ecma402/#sec-lookupsupportedlocales
 * @param availableLocales
 * @param requestedLocales
 */

export function LookupSupportedLocales(availableLocales, requestedLocales) {
  var subset = [];

  for (var _i = 0, requestedLocales_1 = requestedLocales; _i < requestedLocales_1.length; _i++) {
    var locale = requestedLocales_1[_i];
    var noExtensionLocale = locale.replace(UNICODE_EXTENSION_SEQUENCE_REGEX, '');
    var availableLocale = BestAvailableLocale(availableLocales, noExtensionLocale);

    if (availableLocale) {
      subset.push(availableLocale);
    }
  }

  return subset;
}